module.exports = __webpack_public_path__ + "static/SQUARE_wake_trees-9c72b0a250dc13d548b34d1a1ede8c97.jpeg";